
import { Device } from '../DeviceTypes';
import { allEnergyDevices } from './energy-devices';
import { allGasDevices } from './gas-devices';
import { allWaterDevices } from './water-devices';

// Combine all device data from separate department files
export const allDevices: Device[] = [
  ...allEnergyDevices,
  ...allGasDevices,
  ...allWaterDevices
];
